import React, { useCallback } from 'react';
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Link,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { AssetKey, IAsset } from 'api/catalog/models';

import messages from '../messages';

interface IProps {
  asset: IAsset;
}

const DATA_POINTS: AssetKey[] = ['origin', 'source', 'filePath'];

const ImageInformation = ({ asset }: IProps) => {
  const { formatMessage } = useIntl();
  const getLabel = useCallback(
    (key: AssetKey) => {
      switch (key) {
        case 'origin':
          return formatMessage(messages.originLabel);
        case 'source':
          return formatMessage(messages.sourceLabel);
        case 'filePath':
          return formatMessage(messages.filePathLabel);
        default:
          return key;
      }
    },
    [formatMessage]
  );

  const renderCell = useCallback(
    (key: AssetKey) => {
      switch (key) {
        case 'source':
          return (
            <Link href={asset.source} target='_blank'>
              <FormattedMessage {...messages.srcLinkText} />
            </Link>
          );
        default:
          return asset[key];
      }
    },
    [asset]
  );

  return (
    <TableContainer>
      <Table size='small'>
        <TableBody>
          {DATA_POINTS.map((key) => (
            <React.Fragment key={key}>
              {asset[key] ? (
                <TableRow hover>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    {getLabel(key)}
                  </TableCell>
                  <TableCell>{renderCell(key)}</TableCell>
                </TableRow>
              ) : null}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ImageInformation;
